import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "mb-3 text-6xl font-light text-blue" }
const _hoisted_3 = {
  key: 0,
  class: "-mt-4 block text-xl italic text-gray-400 dark:text-gray-500"
}
const _hoisted_4 = {
  key: 1,
  class: "-mt-4 block text-md italic text-gray-400 dark:text-gray-500"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionTitle',
  props: {
  title: {
    type: String,
    required: true,
  },
  subTitle: {
    type: String
  },
  subParagraph: {
    type: String
  }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.title), 1),
    (__props.subTitle)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.subTitle), 1))
      : _createCommentVNode("", true),
    (__props.subParagraph)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.subParagraph), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})